import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onLastStepSubmit", "onComplete", "onNextStep", "setCurrentStep"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import Icon from '@vtblife/uikit-icons';
import React, { useCallback, useEffect, useState } from 'react';
import { InfoStep } from '../info-step/info-step';
import { StepperForm } from '../stepper-form/stepper-form';
import styles from './quiz-content.module.css';
import { execPostSubmitAction } from './utils/exec-post-submit-action';
import { sendQuizAnalytics } from '../../utils/quiz-analytics';
export var QuizContent = function QuizContent(_ref) {
  var _onLastStepSubmit = _ref.onLastStepSubmit,
    onComplete = _ref.onComplete,
    onNextStep = _ref.onNextStep,
    setCurrentStep = _ref.setCurrentStep,
    props = _objectWithoutProperties(_ref, _excluded);
  var _a;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    resultPage = _useState2[0],
    setResultPage = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    showStartPage = _useState4[0],
    setShowStartPage = _useState4[1];
  var quizId = props.id,
    quizName = props.name;
  var _props$steps = props.steps,
    steps = _props$steps === void 0 ? [] : _props$steps,
    startPage = props.startPage,
    progressBar = props.progressBar,
    layout = props.layout,
    background = props.background,
    postSubmitAction = props.postSubmitAction;
  var onLastStepSubmit = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(props) {
      var formData;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            formData = props.formData;
            _context.next = 3;
            return _onLastStepSubmit === null || _onLastStepSubmit === void 0 ? void 0 : _onLastStepSubmit(props);
          case 3:
            if (postSubmitAction && postSubmitAction.length > 0) {
              execPostSubmitAction({
                postSubmitAction: postSubmitAction,
                setResultPage: setResultPage,
                formData: formData
              });
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [postSubmitAction, setResultPage, _onLastStepSubmit]);
  var hasSteps = !!(steps === null || steps === void 0 ? void 0 : steps.length);
  useEffect(function () {
    if (!hasSteps) {
      onLastStepSubmit({
        formData: {},
        fields: []
      });
    }
  }, [onLastStepSubmit, hasSteps]);
  useEffect(function () {
    if (showStartPage) {
      setCurrentStep(0);
      sendQuizAnalytics({
        quizName: quizName,
        quizId: quizId,
        quizStep: 0,
        quizAction: 'show'
      });
    }
  }, [showStartPage, quizName, quizId, setCurrentStep]);
  if (showStartPage && startPage) {
    return React.createElement(StartPage, _objectSpread(_objectSpread({}, startPage), {}, {
      onStart: function onStart() {
        setShowStartPage(false);
        sendQuizAnalytics({
          quizName: quizName,
          quizId: quizId,
          quizStep: 0,
          quizAction: 'continue'
        });
        setCurrentStep(1);
      },
      layout: layout,
      imageSize: background === 'transparent' ? 's' : 'm',
      variant: background === 'transparent' ? 'modal' : 'default'
    }));
  }
  if (resultPage) {
    var resultPageIndex = (_a = props.postSubmitAction) === null || _a === void 0 ? void 0 : _a.findIndex(function (page) {
      var _a;
      return ((_a = page.resultPage) === null || _a === void 0 ? void 0 : _a.title) === resultPage.title;
    });
    var resultPageStep = "result".concat(resultPageIndex);
    setCurrentStep(resultPageStep);
    return React.createElement(ResultPage, _objectSpread(_objectSpread({}, resultPage), {}, {
      layout: layout,
      onComplete: onComplete,
      variant: background === 'transparent' ? 'modal' : 'default',
      resultPageStep: resultPageStep,
      quizId: quizId,
      quizName: quizName
    }));
  }
  if (!hasSteps) {
    return null;
  }
  return React.createElement(StepperForm, {
    quizId: quizId,
    quizName: quizName,
    onLastStepSubmit: onLastStepSubmit,
    steps: steps,
    progressBar: progressBar,
    background: background,
    onNextStep: onNextStep,
    setCurrentStep: setCurrentStep
  });
};
function StartPage(props) {
  var buttonText = props.buttonText,
    quizTimeText = props.quizTimeText,
    onStart = props.onStart;
  return React.createElement(InfoStep, _objectSpread(_objectSpread({}, props), {}, {
    buttons: [{
      text: buttonText,
      onClick: onStart
    }],
    subtitle: quizTimeText ? React.createElement("div", {
      className: styles.quizTimeText
    }, React.createElement(Icon, {
      name: 'timelapse',
      size: 'm'
    }), " ", React.createElement("span", {
      className: styles.text
    }, quizTimeText)) : undefined
  }));
}
function ResultPage(props) {
  var _a;
  return React.createElement(InfoStep, _objectSpread(_objectSpread({}, props), {}, {
    buttons: (_a = props.buttons) === null || _a === void 0 ? void 0 : _a.map(function (button) {
      return _objectSpread(_objectSpread({}, button), {}, {
        onClick: function onClick() {
          props.onComplete({
            quizChoice: button.text,
            quizStep: props.resultPageStep,
            quizAction: button.url ? 'continue' : 'close'
          });
        }
      });
    }),
    imageSize: "s"
  }));
}